const autopayStatusUrl = "v1/credit/billing/payments/autopay";
export {
  autopayStatusUrl
};
//# sourceMappingURL=endpoints.js.map
